export const expertiseAreas = [
  {
    title: 'Type 1 & Type 2 Diabetes',
    description:
      'Clients have worked with Dr. Ali to reverse both types of diabetes through targeted, biology-first protocols rather than lifelong management.',
  },
  {
    title: 'Autoimmune & Inflammatory Conditions',
    description:
      "From rheumatoid arthritis and Graves' disease to cerebral vasculitis, asthma, eczema, and COPD, he addresses the immune dysfunction driving these conditions at its root.",
  },
  {
    title: 'Kidney Function',
    description:
      'He has helped clients facing dialysis restore kidney function and avoid it altogether.',
  },
  {
    title: 'Chronic Pain',
    description:
      'Persistent pain that resisted standard treatment has been resolved through his precision-first approach.',
  },
  {
    title: 'Neurological & Mental Health',
    description:
      'His protocols have supported clients through severe depression, anxiety, epilepsy, and other neurological conditions that standard care could not resolve.',
  },
  {
    title: 'Human Performance',
    description:
      'For those optimizing rather than recovering, he designs advanced protocols using hormones, peptides, and performance-enhancing agents to build lasting strength, vitality, and longevity.',
  },
]

export const differentiators = [
  {
    title: 'Diagnostic precision',
    description:
      'He can identify overlooked pathologies on MRI, EKG, and lab work — sometimes within minutes — that other specialists miss entirely.',
  },
  {
    title: 'Root-cause philosophy',
    description:
      "Your body isn't a set of separate parts. It's one interconnected system, and he treats it that way — fixing the source instead of chasing symptoms.",
  },
  {
    title: 'Peptide mastery',
    description:
      'He has mastered the clinical use of Khavinson peptides and more than 80 others, applying them with rare precision.',
  },
  {
    title: 'Integrated protocols',
    description:
      'Peptides, hormones, testosterone, and other advanced agents are combined into one coherent strategy built around you.',
  },
]

export const testimonials = [
  {
    quote:
      "As a doctor myself, I was skeptical of anything outside standard cardiology protocols. But conventional medicine had nothing left to offer me except a new heart. What you've done isn't just impressive—it's life-changing.",
    author: 'Glen S.',
  },
  {
    quote:
      'Ali… You have done what our entire team of medical professionals were not able to do.',
    author: 'Badar A.',
  },
  {
    quote:
      'I was at rock bottom. Doctors, meds, nothing worked... This… it gave me my life back.',
    author: 'Nick B.',
  },
  {
    quote:
      "I've gone from thinking about my funeral to planning hiking trips. I can't thank you guys and the team enough.",
    author: 'Tony R.',
  },
]

export const sessionBenefits = [
  'A focused review of your situation and what may be holding you back',
  'A step-by-step breakdown of what to do next',
  'Specific guidance that may include what to take, how to take it, timing, dosage, and sourcing',
  'A clearer roadmap toward your health, longevity, and performance goals',
]
